import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Callback from './auth/Callback';
import ProtectedRoute from './auth/ProtectedRoute';
import './index.css';


/**
 * The main entry point for the React application.
 * Contains the route configuration.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Router>
            <Routes>
                {/* Callback route for OIDC */}
                <Route path="/callback" element={<Callback />} />

                {/* Protected route for the main "/" (the serial checker) */}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <App />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    </React.StrictMode>
);
